export default "__VITE_ASSET__C8RIT3aA__"